import {IUser, UserInformation, IWrapper} from '../types';

/**
 * User class implements IUser interface.
 */
class User implements IUser {
  readonly wrapper: IWrapper;

  /**
   * Constructor
   * @param wrapper
   */
  constructor(wrapper: IWrapper) {
    this.wrapper = wrapper;
  }

  /**
   * Get user information
   * @returns {Promise<UserInformation>} - The user profile.
   */
  public getUserInformation(): Promise<UserInformation> {
    return this.wrapper.get<UserInformation>('/v1/MyProfile');
  }
}

export default User;
